module.exports = __webpack_public_path__ + "static/media/assam.a565f84a.png";